import { CheckCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import Typography, { ITypo } from "components/elements/Typography";
import { Link, matchPath, useLocation } from "react-router-dom";
import classes from "./classes.module.scss";

import { EDocumentValidationStatus } from "common/enums/Subscription/EDocumentValidationStatus";

export type IDocumentValidationSteps = {
	status: EDocumentValidationStatus;
	name: string;
	path: string;
};

type IProps = {
	onClickedLink: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, path: string) => void;
	checkValidationIsCompleted: (status: EDocumentValidationStatus) => boolean;
	steps: IDocumentValidationSteps[];
};

export default function ValidationDocumentsStepperCorporation(_props: IProps) {
	const location = useLocation();

	return (
		<div className={classes["root"]}>
			<Typography typo={ITypo.P_LARGE_BOLD} className={classes["title"]}>
				Documents à valider
			</Typography>
			<div className={classes["separator"]} />
			<div className={classes["products"]}>
				{_props.steps.map((step, index) => (
					<Link
						key={index}
						className={classes["product"]}
						onClick={(e) => _props.onClickedLink(e, step.path)}
						to={step.path}
						data-selected={!!matchPath(step.path, location.pathname)}
						data-completed={_props.checkValidationIsCompleted(step.status)}>
						<div key={step.name}>
							<div className={classes["product-header"]}>
								<Typography className={classes["step-text"]} typo={ITypo.P_MEDIUM_BOLD}>
									{step.name}
								</Typography>
								<div className={classes["step-right-section"]}>{checkStatus(step.status)}</div>
							</div>
							<div className={classes["product-separator"]} />
						</div>
					</Link>
				))}
			</div>
		</div>
	);

	function checkStatus(status: EDocumentValidationStatus) {
		if (status === EDocumentValidationStatus.pending) {
			return (
				<div className={classes["icon"]}>
					<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="12" cy="12" r="10" stroke="#000" strokeWidth="1" />
					</svg>
				</div>
			);
		} else if (status === EDocumentValidationStatus.anomalyReported) {
			return (
				<div className={classes["report-anomaly"]}>
					<div className={classes["icon"]}>
						<ExclamationTriangleIcon fill="#F59E0B" />
					</div>
					<Typography typo={ITypo.P_SMALL_BOLD}>Signalé</Typography>
				</div>
			);
		} else if (status === EDocumentValidationStatus.validated) {
			return (
				<div className={classes["icon"]}>
					<CheckCircleIcon fill="#29904F" />
				</div>
			);
		} else {
			return null;
		}
	}
}
